import type { MetaDescriptor } from '@remix-run/node';
import type { VideoObject } from 'schema-dts';

interface VideoSchemaProps {
    name: string;
    publishDate: string;
    professionalName: string;
    url: string;
    thumbnailUrl: string;
    description: string;
}

export const createVideoSchema = (
    props: VideoSchemaProps
): MetaDescriptor[] => {
    const {
        name,
        publishDate,
        professionalName,
        url,
        thumbnailUrl,
        description,
    } = props;
    const createVideoSchema: VideoObject = {
        '@type': 'VideoObject',
        name,
        '@id': url,
        datePublished: publishDate,
        uploadDate: publishDate,
        author: {
            '@type': 'Organization',
            name: professionalName,
        },
        contentUrl: url,
        embedUrl: url,
        thumbnailUrl: [thumbnailUrl],
        description: description,
    };
    return [createVideoSchema];
};
